(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "./index.less"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("./index.less"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.index);
    global.unknown = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _index) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default2 = {
    render: function render() {
      var _vm = this;

      var _h = _vm.$createElement;

      var _c = _vm._self._c || _h;

      return _vm.show ? _c('div', {
        ref: "floating",
        staticClass: "nx-floating-dialog",
        on: {
          "click": _vm.$_click
        }
      }, [_c('img', {
        staticClass: "init",
        class: !_vm.transition ? 'hide' : '',
        attrs: {
          "src": _vm.imgUrl,
          "tabindex": -1,
          "role": "option",
          "alt": "",
          "aria-label": _vm.ariaLabelContent
        }
      }), _vm.showClose ? _c('div', {
        staticClass: "nx-floating-close",
        class: !_vm.transition ? 'hide' : '',
        attrs: {
          "aria-label": "关闭",
          "role": "button"
        },
        on: {
          "click": function click($event) {
            $event.stopPropagation();
            return _vm.$_close($event);
          }
        }
      }) : _vm._e()]) : _vm._e();
    },
    name: 'nx-floating-dialog',
    props: {
      imgUrl: {
        type: String,
        required: true
      },
      ariaLabelContent: {
        type: String,
        default: ''
      },
      showClose: {
        type: Boolean,
        default: true
      },
      scrollTransition: {
        type: Boolean,
        default: true
      },
      appendTo: {
        default: function _default() {
          return document.body;
        },
        validator: function validator(value) {
          return value instanceof HTMLElement;
        }
      }
    },
    data: function data() {
      return {
        scrollDistance: '',
        lastScrollTop: 0,
        transition: true,
        scrollTop: 0,
        show: true
      };
    },
    watch: {
      scrollTop: function scrollTop(newValue) {
        var _this = this;

        setTimeout(function () {
          if (newValue === _this.scrollTop) {
            _this.transition = true;
          }
        }, 100);
      }
    },
    mounted: function mounted() {
      this.scrollTransition && window.addEventListener('scroll', this.menu);
      this.appendTo && this.appendTo.appendChild(this.$el);
    },
    methods: {
      menu: function menu() {
        this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        var scrollDistance = this.scrollTop - this.lastScrollTop;
        this.lastScrollTop = this.scrollTop;

        if (scrollDistance < 0) {
          // 向下滑动
          this.transition = true;
        } else {
          // 向上滑动
          this.transition = false;
        }
      },
      $_click: function $_click(e) {
        this.$emit('click', e);
      },
      $_close: function $_close(e) {
        this.$emit('close', e);
        this.show = false;
      }
    },
    beforeDestroy: function beforeDestroy() {
      if (this.appendTo && this.appendTo.contains(this.$el)) {
        this.appendTo.removeChild(this.$el);
      }

      this.scrollTransition && window.removeEventListener('scroll', this.menu); // 离开当前组件别忘记移除事件监听哦
    }
  };
  _exports.default = _default2;
});